module.exports = __webpack_public_path__ + "static/img/item8.25f5673.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/item8.png
// module id = BryL
// module chunks = 1